import React from 'react';
import type { ComponentProps } from 'react';
import { Grid, Text, Box, ResponsiveSection } from '@stitch-fix/mode-react';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageFields,
} from '../CloudinaryImageWrapper';
import { Testimonials } from './Testimonials';
import styles from './styles.module.scss';

export interface StylistModuleProps {
  description: string;
  header: string;
  image: CloudinaryImageFields;
  testimonials: ComponentProps<typeof Testimonials>['testimonials'];
}

export const StylistModule = ({
  description,
  header,
  image,
  testimonials,
}: StylistModuleProps) => {
  const hasTestimonials = testimonials.length > 0;

  return (
    <ResponsiveSection width="xxlarge">
      <Grid
        columns={{ sm: 1, lg: 2 }}
        mb={{ lg: hasTestimonials ? '44px' : 0 }}
      >
        <Box className={styles.imageContainer}>
          <CloudinaryImageWrapper
            src={image.src}
            alt={image.alt}
            aspectRatio={image.aspectRatio}
            sources={{ sm: 375, md: 540 }}
            cloudinaryAsset={image.cloudinaryAsset}
            sizes={[
              { minWidth: 0, fluidWidth: 100 },
              { minWidth: 600, staticWidth: 540 },
              { minWidth: 900, fluidWidth: 50 },
            ]}
            maxContainerWidth="lg"
            imageProps={{ loading: 'lazy' }}
          />
        </Box>
        <Box py={{ lg: '44px' }} pl={{ lg: '44px' }} maxWidth="540px">
          <Text
            as="h2"
            setting="title-large"
            spacingBottom
            className={styles.header}
          >
            {header}
          </Text>
          <Text
            setting="body-medium-fixed"
            className={styles.description}
            spacingBottom
          >
            {description}
          </Text>
        </Box>
      </Grid>
      {hasTestimonials && <Testimonials testimonials={testimonials} />}
    </ResponsiveSection>
  );
};
